<template>
    <button :disabled="loading" class="btn btn-primary font-weight-bolder" v-bind="$attrs">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        loading: Boolean,
    },
}
</script>
